import {useCurrencyFormatter as useInfraCurrencyFormatter, useTranslation} from '@wix/yoshi-flow-editor'
import {getCountry, getLocale} from '../../../../commons/selectors/environment'
import {getCurrencyFormatter} from '../../../../commons/utils/currency-formatter'
import {useMembersPageSelector} from './runtime'

export const useMembersPageCurrencyFormatter = () => {
  const locale = useMembersPageSelector(getLocale)
  const country = useMembersPageSelector(getCountry)
  const formatCurrency = useInfraCurrencyFormatter({language: locale, country})
  const {t} = useTranslation()

  return getCurrencyFormatter({t, formatCurrency})
}
